import { render } from "./StudentSubmissionUtil.vue?vue&type=template&id=067e199c"
import script from "./StudentSubmissionUtil.vue?vue&type=script&lang=js"
export * from "./StudentSubmissionUtil.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__